import { useEffect, useRef, useState } from 'react'

import { navigate, routes, useParams } from '@redwoodjs/router'
import { Metadata } from '@redwoodjs/web'

import { useCallDrawerContext } from 'src/context/CallDrawerContext'

import CallHistoryTab from './components/CallHistoryTab'
import CustomTab from './components/CustomTab'
import EmailsTab from './components/EmailsTab'

const ActivitiesPage = () => {
  const { id } = useParams()
  const { handleOpen: openCallDrawer, opened: callDrawerOpened } =
    useCallDrawerContext()
  const activityLogRef = useRef(null)
  const [totalCalls, setTotalCalls] = useState(0)

  // Determine the current tab based on the URL path
  const currentPath = window.location.pathname
  const isEmailsTab = currentPath.includes('/emails')
  const selectedTab = isEmailsTab ? 'emails' : 'callHistory'

  // When the call drawer is opened, we add the activityLogId to the url and preserve the current filters
  const handleOpen = (activityLogId) => {
    const currentUrl = new URL(window.location.href)
    const currentParams = currentUrl.search
    navigate(
      `/communications/calls/${activityLogId}${currentParams.toString()}`
    )
  }

  // When the call drawer is closed, we remove the activityLogId from the url but still preserve the filters
  useEffect(() => {
    if (!callDrawerOpened && id === activityLogRef.current) {
      const currentUrl = new URL(window.location.href)
      const currentParams = currentUrl.search
      navigate(`/communications/calls${currentParams.toString()}`)
    }
  }, [callDrawerOpened])

  // When the page is loaded, if there is an activityLogId in the url, we open the call drawer
  useEffect(() => {
    if (id && id !== activityLogRef.current && !isEmailsTab) {
      activityLogRef.current = id
      openCallDrawer(id)
    }
  }, [id, isEmailsTab])

  return (
    <div className="flex h-full w-full flex-col overflow-hidden px-5 pb-5">
      <Metadata title="Communications" description="Communications page" />

      <div className="flex w-full flex-row items-center justify-between">
        <div className="flex w-full flex-row gap-2 ">
          <CustomTab
            selectedTab={selectedTab}
            value="callHistory"
            label={
              <div className="flex flex-row items-center gap-2">
                <div>Call History</div>
                {selectedTab === 'callHistory' && (
                  <div className="text-xs text-doubleNickel-gray-600">
                    {totalCalls}
                  </div>
                )}
              </div>
            }
            setSelectedTab={() => {}}
            onClick={() => {
              navigate(routes.communications())
            }}
          />
          <CustomTab
            selectedTab={selectedTab}
            value="emails"
            label="Emails"
            setSelectedTab={() => {}}
            onClick={() => {
              navigate(routes.emails())
            }}
          />
        </div>
      </div>

      {selectedTab === 'callHistory' && (
        <CallHistoryTab onOpen={handleOpen} setTotalCalls={setTotalCalls} />
      )}

      {selectedTab === 'emails' && <EmailsTab />}
    </div>
  )
}

export default ActivitiesPage
